/*
===============================================================================================================
                                 Copyright 2024-2024, Blue Yonder Group, Inc.
                                             All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/
import { RETURN_METHOD_TYPE } from '@/utilities/return-method-types';

const getValue = ({ context, translate }) => {
  const { getReturnMethodsConfig } = context;

  if (!getReturnMethodsConfig) {
    return null;
  }

  const createTranslation = (val) => translate(`instoreReturns.promoteInstoreReturns.${val}`);

  const returnMethods = getReturnMethodsConfig();
  const storeDropOff = returnMethods[RETURN_METHOD_TYPE.STORE_DROP_OFF] || {};
  const carrier = returnMethods[RETURN_METHOD_TYPE.CARRIER] || {};
  const homePickup = returnMethods[RETURN_METHOD_TYPE.HOME_PICKUP] || {};

  return {
    enabled: storeDropOff.enabled,
    fields: [
      { id: 'label', value: storeDropOff.label, label: createTranslation('promotionalTag') },
      { id: 'storeFooter', value: storeDropOff.footer, label: createTranslation('storeFooter') },
      { id: 'storeFooterBackground', value: storeDropOff.footerBackground, label: createTranslation('storeFooterBackground') },
      { id: 'carrierDropOffFooter', value: carrier.footer, label: createTranslation('carrierDropOffFooter') },
    ],
    homePickup: {
      enabled: homePickup.enabled,
    },
  };
};

export default getValue;
